module.exports = __webpack_public_path__ + "static/media/misty-lose.970d13fa.png";